export const toUppercaseFirstLetter = (value: string) => value.charAt(0).toUpperCase();
